















import { WidgetImportErrorHolder } from '@holistic/shared/src/domain/widgets/WidgetImportErrorHolder';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class Reports extends Vue {
  @Prop(Object) private errorHolder!: WidgetImportErrorHolder;

  public get moreErrorDetails() {
    const { message, ...errorWithoutMessage } = this.errorHolder.error;
    return errorWithoutMessage;
  }
}
